import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ICheckBlock } from './interface/check-block.interface';

@Injectable()
export class CheckBlockService {
  private readonly base = `${environment.cprServiceApi}check-block`;

  constructor(
    private readonly dialog: MatDialog,
    private readonly http: HttpClient,
  ) {}

  delete(id: string, callback?: () => void) {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        onConfirm: async () => {
          await lastValueFrom(this.http.delete(`${this.base}/${id}`));
          callback?.();
        },
        title: 'Delete Checkblock',
        body: 'Are you sure you want to delete this checkblock? The conversation will be lost.',
      },
    });
  }

  get(id: string) {
    return lastValueFrom(this.http.get<ICheckBlock>(`${this.base}/${id}`));
  }

  getBySampleAndTaxon(sampleid: string, taxonid: string) {
    return lastValueFrom(
      this.http.get<ICheckBlock<true>>(this.base, {
        params: { sampleid, taxonid },
      }),
    );
  }

  addMessage(sampleId: string, taxonId: string, message: string) {
    return lastValueFrom(
      this.http.post(`${this.base}/message`, {
        message,
        sampleId,
        taxonId,
      }),
    );
  }

  assign(id: string, userId: string) {
    return lastValueFrom(this.http.post(`${this.base}/${id}/assign`, { userId }));
  }

  raiseCheckBlock(sampleId: string, taxonId: string, message: string) {
    return lastValueFrom(
      this.http.post(this.base, {
        message,
        sampleId,
        taxonId,
      }),
    );
  }
  closeCheckBlock(id: string, result: string, callback?: () => void) {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        onConfirm: async () => {
          await lastValueFrom(this.http.post(`${this.base}/${id}/close`, { result }));
          callback?.();
        },
        title: 'Mark Checkblock as Resolved',
        body: 'This action will mark the checkblock as resolved and leave it in a read-only state.',
      },
    });
  }

  reopen(id: string, callback?: () => void) {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        onConfirm: async () => {
          await lastValueFrom(this.http.post(`${this.base}/${id}/reopen`, undefined));
          callback?.();
        },
        title: 'Reopen Checkblock',
        body: 'This action will reopen the checkblock and enable the conversation again.',
      },
    });
  }

  getUserActiveCheckBlocks(userId: string, limit?: number) {
    return lastValueFrom(
      this.http.get<ICheckBlock[]>(
        `${this.base}/activeforuser/${userId}`,
        limit ? { params: { limit } } : undefined,
      ),
    );
  }
}
